import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/rc-notification/es/index.js
// module id = null
// module chunks = 